var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4614_18172)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9996 10.5118V2.33557C13.9996 1.22948 12.524 0.00683594 11.7804 0.00683594H3.45853C3.03078 0.00683594 2.32331 0.340178 2.32331 1.10127C2.32331 2.17938 3.46086 2.29943 3.46086 2.29943H10.489C10.489 2.29943 11.6347 2.31692 11.6347 3.62814V10.5456C11.6347 10.5456 11.7991 11.6575 12.7967 11.6575C13.8189 11.6575 13.9996 10.5118 13.9996 10.5118ZM10.4692 5.82866V11.6738C10.4692 12.7088 10.0869 14.0025 8.17776 14.0025H2.2965C0.679913 14.0025 0.00390625 12.6342 0.00390625 11.6738V5.82866C0.00390625 4.28317 1.11699 3.4638 2.2965 3.4638H8.0682C10.0135 3.4638 10.4692 5.08505 10.4692 5.82866Z",
    fill: "#1B1A57",
    fillOpacity: 0.23
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4614_18172"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.48058cf20eb578472b13537cbba20b6b.svg";
export { ForwardRef as ReactComponent };